import { useEffect, useMemo, useRef, useState } from "react";

import { getConceptById } from "../concept-trees/globalTreeStoreHelper";
import { nodeIsConceptQueryNode } from "../model/node";
import { StandardQueryNodeT } from "../standard-query-editor/types";

interface AutoLabelProps {
  node: StandardQueryNodeT;
  onUpdateLabel: (label: string) => void;
}

export function useAutoLabel({ node, onUpdateLabel }: AutoLabelProps) {
  const MAX_AUTOLABEL_LENGTH = 250;
  const DELIMITER = " ";

  const formatConceptLabels = (labels: string[]) =>
    labels.sort().join(DELIMITER).substring(0, MAX_AUTOLABEL_LENGTH);

  const autoLabel = useMemo(() => {
    return nodeIsConceptQueryNode(node)
      ? formatConceptLabels(
          node.ids.map((id) => getConceptById(id)?.label ?? ""),
        )
      : undefined;
  }, [node]);

  const [autoLabelEnabled, setAutoLabelEnabled] = useState(
    nodeIsConceptQueryNode(node) && node.label === autoLabel,
  );

  const onUpdateLabelRef = useRef(onUpdateLabel);
  onUpdateLabelRef.current = onUpdateLabel;
  useEffect(
    function updateLabelWithAutogenerated() {
      if (autoLabelEnabled && autoLabel && node.label !== autoLabel) {
        onUpdateLabelRef.current(autoLabel);
      }
    },
    [autoLabel, autoLabelEnabled, node.label],
  );

  return { autoLabel, autoLabelEnabled, setAutoLabelEnabled };
}
